import { Card, CardContent, Divider, Grid, Skeleton, Typography } from '@mui/material';

export const LoadingCard: React.FC = () => (
  <Card sx={{ mb: 2, width: '100%' }}>
    <Grid container>
      <Grid size={6}>
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Skeleton width="40%" animation="wave" />
          <Skeleton animation="wave" />
          <Divider
            variant="fullWidth"
            sx={{
              paddingTop: 2,
            }}
          />
          <Skeleton
            sx={{
              marginTop: 2,
            }}
            variant="rectangular"
            width="100%"
            height="60px"
            animation="wave"
          />
        </CardContent>
      </Grid>
      <Grid size={2}>
        <CardContent>
          <Typography component="div" variant="headingXxs">
            <Skeleton width="40%" animation="wave" />
          </Typography>
          <Typography variant="paragraph" color="text.secondary" component="div">
            <table>
              <tbody>
                <tr>
                  <td>
                    <Skeleton sx={{ fontSize: '0.9rem' }} width="130px" animation="wave" />
                  </td>
                  <td>
                    <Skeleton sx={{ fontSize: '0.9rem' }} width="300px" animation="wave" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton sx={{ fontSize: '0.9rem' }} width="130px" animation="wave" />
                  </td>
                  <td>
                    <Skeleton sx={{ fontSize: '0.9rem' }} width="300px" animation="wave" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton sx={{ fontSize: '0.9rem' }} width="130px" animation="wave" />
                  </td>
                  <td>
                    <Skeleton sx={{ fontSize: '0.9rem' }} width="300px" animation="wave" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton sx={{ fontSize: '0.9rem' }} width="130px" animation="wave" />
                  </td>
                  <td>
                    <Skeleton sx={{ fontSize: '0.9rem' }} width="300px" animation="wave" />
                  </td>
                </tr>
              </tbody>
            </table>
          </Typography>
        </CardContent>
      </Grid>
    </Grid>
  </Card>
);
